import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function PublicFooter() {
  return (
    <footer className="border-t border-zinc-900 bg-black/60 mt-24 py-12 px-4 text-sm" data-testid="public-footer">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-4 gap-8">
        <div>
          <img src="/logo.png" alt="FutureXV" className="h-10 mb-3" />
          <p className="text-zinc-400 leading-relaxed">
            South Africa&rsquo;s National Digital Rugby Discovery &amp; Development Platform.
          </p>
        </div>
        <div>
          <p className="text-white font-bold mb-3">Platform</p>
          <ul className="space-y-2 text-zinc-400">
            <li><Link to="/about" className="hover:text-[#A3FF00]">About</Link></li>
            <li><Link to="/features" className="hover:text-[#A3FF00]">Features</Link></li>
            <li><Link to="/pricing" className="hover:text-[#A3FF00]">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-white font-bold mb-3">Audiences</p>
          <ul className="space-y-2 text-zinc-400">
            <li><Link to="/for-players" className="hover:text-[#A3FF00]">For Players</Link></li>
            <li><Link to="/for-schools" className="hover:text-[#A3FF00]">For Schools & Clubs</Link></li>
            <li><Link to="/for-scouts" className="hover:text-[#A3FF00]">For Scouts</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-white font-bold mb-3">Legal & Contact</p>
          <ul className="space-y-2 text-zinc-400">
            <li><Link to="/security-compliance" className="hover:text-[#A3FF00]">Security & Compliance</Link></li>
            <li><Link to="/privacy" className="hover:text-[#A3FF00]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#A3FF00]">Terms of Service</Link></li>
            <li><Link to="/contact" className="hover:text-[#A3FF00]">Contact</Link></li>
            <li className="flex items-center gap-2 pt-1"><Mail className="w-3.5 h-3.5" /><a href="mailto:info@futurexv.co.za" className="hover:text-[#A3FF00]">info@futurexv.co.za</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto mt-10 pt-6 border-t border-zinc-900 text-xs text-zinc-500 flex flex-col md:flex-row justify-between gap-3">
        <span>&copy; {new Date().getFullYear()} FutureXV. All rights reserved.</span>
        <span>futurexv.co.za</span>
      </div>
    </footer>
  );
}
